import React, { useState, useEffect } from 'react';
import { getFirebaseApp } from '../utils/firebase';
import { useAuth, Login } from '..';
import { Dropdown, Button, Icon } from 'semantic-ui-react';
import './ProfileWidget.css';
import './commonStyles.css';
export var ProfileWidget = function () {
    var user = useAuth();
    var _a = useState(false), login = _a[0], setLogin = _a[1];
    useEffect(function () {
        if (user && login) {
            setLogin(false);
        }
    }, [user, login]);
    var signOut = function () { return getFirebaseApp().auth().signOut(); };
    return (React.createElement("div", { id: "profile-widget" },
        login && React.createElement(Login, { title: "", onClose: function () { return setLogin(false); } }),
        user ? (React.createElement(Dropdown, { trigger: React.createElement(Button, { className: "profile-button", icon: true, size: "large" },
                React.createElement(Icon.Group, null,
                    React.createElement(Icon, { name: "user outline" }))), pointing: "top right", icon: null },
            React.createElement(Dropdown.Menu, null,
                React.createElement(Dropdown.Item, { disabled: true }, user.email),
                React.createElement(Dropdown.Divider, null),
                React.createElement(Dropdown.Item, { onClick: signOut },
                    React.createElement(Icon, { name: "log out" }),
                    "Log out")))) : (React.createElement(Button, { primary: true, size: "large", onClick: function () { return setLogin(true); } }, "Sign in"))));
};
//# sourceMappingURL=ProfileWidget.js.map